import React from "react";
import EyeOpen from "../Icons/EyeOpen/EyeOpen";
import EyeClosed from "../Icons/EyeClosed/EyeClosed";
import "./VisibilityIcon.css";

const VisibilityIcon = (props) => {
  if (props.isVisible) {
    return (
      <div className="visibility-icon" onClick={props.toggleVisibility}>
        <EyeOpen />
      </div>
    );
  } else {
    return (
      <div className="visibility-icon" onClick={props.toggleVisibility}>
        <EyeClosed />
      </div>
    );
  }
};

export default VisibilityIcon;
